import React from 'react';
import {observer} from 'mobx-react';

interface CarouselArrowProps {
    onClick: () => void;
    isEnabled: boolean;
    direction: 'prev' | 'next';
    arrowIcon: JSX.Element;
}

export const CarouselArrow: React.FC<CarouselArrowProps> = observer(({onClick, isEnabled, direction, arrowIcon}) => {
    const className = direction === 'prev' ? 'custom-arrow custom-arrow-prev' : 'custom-arrow custom-arrow-next';
    const arrowContent =
        direction === 'prev' ? (
            <div style={{transform: 'rotate(180deg)', display: 'flex'}}>{arrowIcon}</div>
        ) : (
            arrowIcon
        );

    return (
        <button
            onClick={onClick}
            className={className}
            style={{opacity: isEnabled ? 1 : 0.3, cursor: isEnabled ? 'pointer' : 'default'}}>
            {arrowContent}
        </button>
    );
});
